// Contracts → Client Agreements: Hollypaul's copies of agreements signed on a second
// business's own site (e.g. the Samson Transport NDA). Their site sends the signed PDF here
// when the last person signs (netlify/functions/tenant-agreement-copy.js). Read-only.
import React, { useState, useEffect } from 'react';
import { Download, Loader, CheckCircle } from 'lucide-react';

const API = '/.netlify/functions/tenant-agreement-copy';
const post = (body) => fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
const when = (iso) => (iso ? new Date(iso).toLocaleString('en-AU', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');

export default function ClientAgreementsTab() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState('');
  const [dl, setDl] = useState('');

  useEffect(() => {
    post({ action: 'list' })
      .then((d) => { if (!d.success) throw new Error(d.error || 'Could not load'); setItems(d.items); })
      .catch((e) => { setErr(e.message); setItems([]); });
  }, []);

  const download = async (it) => {
    setDl(it.key);
    try {
      const d = await post({ action: 'pdf', key: it.key });
      if (!d.success) throw new Error(d.error);
      const bytes = Uint8Array.from(atob(d.base64), (c) => c.charCodeAt(0));
      const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      const a = document.createElement('a'); a.href = url; a.download = d.filename; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) { setErr(e.message); } finally { setDl(''); }
  };

  if (items === null) return <div style={{ padding: 16 }}><Loader size={16} /> Loading…</div>;
  return (
    <div className="card" style={{ padding: 18 }}>
      <p style={{ margin: '0 0 14px', fontSize: '0.85rem', color: 'var(--hp-dim)' }}>
        Agreements signed on a client business's own engine site. A copy arrives here automatically when the last person signs.
      </p>
      {err && <div style={{ color: 'var(--hp-red)', marginBottom: 10 }}>{err}</div>}
      {!items.length && <p style={{ color: 'var(--hp-dim)' }}>No signed client agreements yet.</p>}
      {!!items.length && (
        <div style={{ overflowX: 'auto' }}>
          <table className="table" style={{ width: '100%' }}>
            <thead><tr><th>Business</th><th>Agreement</th><th>Signed by</th><th>Completed</th><th /></tr></thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.key}>
                  <td>{it.business}</td>
                  <td>{it.title}{it.version > 1 ? ` (v${it.version})` : ''}</td>
                  <td style={{ fontSize: '0.82rem' }}>
                    {it.signers.map((s) => <div key={s.login}><CheckCircle size={12} color="#22c55e" /> {s.fullName} <span style={{ color: 'var(--hp-dim)' }}>· {s.position}</span></div>)}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{when(it.completedAt)}</td>
                  <td>
                    <button className="btn btn-secondary btn-sm" onClick={() => download(it)} disabled={dl === it.key}>
                      {dl === it.key ? <Loader size={13} /> : <Download size={13} />} PDF
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
